import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from './components/HeroSection';
import SkillsPreview from './components/SkillsPreview';
import GitHubActivity from './components/GitHubActivity';
import RecentHighlights from './components/RecentHighlights';
import TestimonialCarousel from './components/TestimonialCarousel';
import AnimatedSection from '../../components/AnimatedSection';

const HomepageHeroExperienceHub = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen"
    >
      {/* Hero Section */}
      <HeroSection />

      {/* Skills Preview Section */}
      <AnimatedSection variant="fadeUp">
        <SkillsPreview />
      </AnimatedSection>

      {/* GitHub Activity Section */}
      <AnimatedSection variant="slideLeft" delay={0.2}>
        <GitHubActivity />
      </AnimatedSection>

      {/* Recent Highlights Section */}
      <AnimatedSection variant="scaleIn" delay={0.3}>
        <RecentHighlights />
      </AnimatedSection>

      {/* Testimonial Carousel Section */}
      <AnimatedSection variant="slideRight" delay={0.4}>
        <TestimonialCarousel />
      </AnimatedSection>
    </motion.div>
  );
};

export default HomepageHeroExperienceHub;